<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__checklog}">
      <div class="flex justify-between">
        <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
        >
          <el-form-item label="仓库：">
            <storages
              v-model="dataForm.storageId"
              :defaultItem="null"
              :autoDefault="true"
              @change="storageChangeHandle"
            ></storages>
          </el-form-item>
          <el-form-item label="搜索：">
            <el-input
              v-model="dataForm.name"
              placeholder="输入产品名称或规格进行搜索"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="品番号：">
            <el-input
              v-model="dataForm.code"
              placeholder="输入品番号进行搜索"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getDataList()">{{ $t("query") }}</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" @click="dataFormSubmitHandle"
            >确认盘点</el-button
          >
        </div>
      </div>

      <el-form ref="form" :model="postForm" :rules="rules" label-width="120px">
        <el-table
          v-loading="dataListLoading"
          :data="postForm.dataList"
          border
          @selection-change="dataListSelectionChangeHandle"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            header-align="center"
            align="center"
            width="50"
            label="#"
          ></el-table-column>
          <el-table-column
            prop="storageName"
            label="当前仓库"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="text-blue-600" v-if="scope.row.storageName">
                {{ scope.row.storageName }}
              </div>
              <div class="text-red-600" v-else>暂无库存记录</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            label="品番号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="产品名称"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              {{ $productName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="beforeCount"
            label="当前库存"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="afterCount"
            label="盘点后库存"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="'dataList.' + scope.$index + '.afterCount'"
                :rules="rules.afterCount"
                label-width="0"
                style="margin-bottom: 0"
              >
                <el-input
                  v-model="scope.row.afterCount"
                  placeholder="盘点后库存"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="调整原因"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="'dataList.' + scope.$index + '.remark'"
                :rules="rules.remark"
                label-width="0"
                style="margin-bottom: 0"
              >
                <el-input
                  v-model="scope.row.remark"
                  placeholder="请输入调整原因"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import debounce from "lodash/debounce";
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/product/page",
        getDataListIsPage: true,
        deleteIsBatch: true,
        activatedIsNeed: false,
      },
      dataForm: {
        name: "",
        code: "",
        storageId: "",
      },
      postForm: {
        dataList: [],
      },
    };
  },
  computed: {
    rules() {
      return {
        afterCount: [
          {
            validator: function (rule, value, callback) {
              let n = parseInt(value);
              if (isNaN(n)) {
                callback(new Error("请输入正确的数量"));
              }
              callback();
            },
            trigger: "change",
          },
        ],
      };
    },
  },
  components: {},
  methods: {
    storageChangeHandle() {
      this.getDataList();
    },
    beforeTableBinding(dataList) {
      if (!dataList) {
        return;
      }
      dataList.forEach((item) => {
        item.remark = "";
        item.beforeCount = item.count;
        item.afterCount = item.count;
        item.productId = item.id;
        item.storageId = this.dataForm.storageId;
        delete item.count;
        delete item.id;
      });
      this.postForm.dataList = [...dataList];
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return false;
          }
          let dataList = this.postForm.dataList.filter((item) => {
            if (!item.afterCount || item.beforeCount === item.afterCount) {
              return false;
            }
            return true;
          });
          if (dataList.length === 0) {
            return;
          }
          this.$http
            .post("/trade/checklog/", dataList)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.getDataList();
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
